import { physicalDistributionTemplateFormToQuery as formToQuery } from './physicalDistributionTemplateFormToQuery';
import { physicalDistributionTemplateQueryToForm as queryToForm } from './physicalDistributionTemplateQueryToForm';

export default { formToQuery, queryToForm };
